import { render, staticRenderFns } from "./MainArticles.vue?vue&type=template&id=905ea2a6&scoped=true&"
import script from "./MainArticles.vue?vue&type=script&lang=js&"
export * from "./MainArticles.vue?vue&type=script&lang=js&"
import style0 from "./MainArticles.vue?vue&type=style&index=0&id=905ea2a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905ea2a6",
  null
  
)

export default component.exports